export default () => ({
  schedules: []
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/consultations-made/resources/data.js